"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var communicationHub_1 = require("../mock/communicationHub");
var CommunicationHubAPIs = {
    fetchUsers: function (token, body) {
        return rest_1.default.post({
            mockFunc: communicationHub_1.fetchUsers,
            url: (0, combinePlatformUrl_1.default)('/api/v2/communications/fetch-users'),
            body: body,
            token: token,
        });
    },
    getFilterData: function (token) {
        return rest_1.default.get({
            mockFunc: communicationHub_1.getFilterData,
            url: (0, combinePlatformUrl_1.default)('/api/v2/communications/filter-data'),
            token: token,
        });
    },
};
exports.default = CommunicationHubAPIs;
